import React, {useState} from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Styles from './styles.module.scss'
import {useDispatch, useSelector} from "react-redux";

import {setMatrixSellModalStatus, setMatrixSellSuccessModalStatus} from "../../store/cabinet/action";
import cfpIcon from "../../theme/assets/other/ftf_cft_icon2.png";
import usdtIcon from "../../theme/assets/other/ftf_usdt_icon.png";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";



const CabinetMatrixSellModal = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const matrixSellModalStatus = useSelector(store => store.cabinet.matrixSellModalStatus);

    const [amount, setAmount] = useState('');

    const handleChange = (e) => {
        let newValue = e.target.value;
        // Разрешаем только цифры и точку
        newValue = newValue.replace(/[^0-9.]/g, '');

        // Разрешаем ввод только одной точки
        const parts = newValue.split('.');
        if (parts.length > 2) {
            newValue = parts[0] + '.' + parts.slice(1).join('');
        }

        const numericValue = parseFloat(newValue);
        if (!isNaN(numericValue) && numericValue > 454) {
            newValue = '454';
        }

        setAmount(newValue);
    };

    const closeModal = () =>{
        dispatch(setMatrixSellModalStatus(false));
    }

    const settingsHandler = () =>{
        navigate('/settings');
        closeModal();
    }

    const mainBtnHandler = () =>{
        closeModal();
        dispatch(setMatrixSellSuccessModalStatus(true));
    }

    return (
        <Popup
            open={matrixSellModalStatus}
            modal
            nested
            closeOnDocumentClick
            onClose={closeModal}
        >
            <div className={`${Styles.modalContainer}`}>
                <div className={`${Styles.modalCloseBtn}`} onClick={()=>{closeModal()}}>
                    <div/>
                    <div/>
                </div>
                <div className={`${Styles.modalContentWrap}`}>
                    <div className={`${Styles.modalTitle}`}>{t('Продать токены')}</div>
                    <div className={`${Styles.inputsPosWrap}`}>
                        <div className={`${Styles.inputWrap}`}>
                            <div className={`${Styles.inputTitle}`}>{t('Введите количество токенов для продажи')}:</div>
                            <div className={`${Styles.inputWrapAbsCurrencyWI}`}>{t('Токены')}</div>
                            <div className={`${Styles.inputWrapAbsIconWI}`}>
                                <img src={cfpIcon} alt="CFP"/>
                            </div>
                            <input
                                type="text"
                                className={`${Styles.ftfBorderInput}`}
                                value={amount}
                                onChange={handleChange}
                            />
                            <div className={`${Styles.inputDataRow}`}>
                                <div className={`${Styles.balance}`} onClick={()=>{setAmount('454')}}>{t('Доступно токенов')}: 454</div>
                                <div className={`${Styles.course}`}>1 CFP = 2 USDT</div>
                            </div>
                        </div>
                        <div className={`${Styles.inputWrap}`}>
                            <div className={`${Styles.inputTitle}`}>{t('Вы получите')} USDT:</div>

                            <div className={`${Styles.fakeInput} ${Styles.ftfBorderInput}`}>
                                {amount ? Number(amount) * 2 : '0'}
                                <div className={`${Styles.inputWrapAbsCurrency}`}>USDT</div>
                                <div className={`${Styles.inputWrapAbsIcon}`}>
                                    <img src={usdtIcon} alt="USDT"/>
                                </div>
                            </div>
                            <div className={`${Styles.inputDataRow}`}>
                                <div className={`${Styles.commission}`}>{t('Комиссия')}: 1 USDT</div>
                            </div>
                        </div>
                    </div>
                    <div className={`${Styles.ftfDisabledBtn}`} onClick={mainBtnHandler}>Sell</div>
                    <div className={`${Styles.sellNote}`}>{t('У вас не привязан кошелёк USDT')}! <span onClick={settingsHandler}>{t('Настройки')}</span></div>
                </div>
            </div>
        </Popup>
    );
};

export default CabinetMatrixSellModal;
